<template>
  <div>
    <div class="order">
      <!-- <div class="products">
        <div>
          <i class="el-icon-s-order"></i>
          <h5>訂單内容</h5>
        </div>
        <h5>食物內容</h5>
        <div class="meal">
          <div>1x</div>
          <div>
            {{ meal.name }}
            <div v-for="(item, index) in meal.classify" :key="index">
              <p v-for="(el, key) in item.dishes" :key="key">
                -{{ el.count }}x {{ el.name }}
              </p>
            </div>
          </div>
          <div>${{(meal.price).toFixed(2)}}</div>
        </div>
        <hr />
        <div class="total">
          <div>總價</div>
          <div>${{((meal.price)*(meal.count).toFixed(2) || meal.price)}}</div>
        </div>
      </div> -->
      <v-order
        :meal="meal"
        :form="form"
        :additional="additional"
        :way="way"
      ></v-order>
      <div class="orderform">
        <el-form
          :label-position="labelPosition"
          label-width="100px"
          :model="form"
          size="mini"
          :rules="rules"
          ref="ruleForm"
        >
          <div class="form-item">
            <el-form-item
              :label="way === 'self' ? '自取日期：' : '送貨日期：'"
              prop="date"
            >
              <el-date-picker
                v-model="form.date"
                type="date"
                placeholder="選擇日期"
                popper-class="date-style"
                @change="handChange"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item
              v-if="way === 'self'"
              label="自取地點："
              prop="arrdress"
            >
              <el-select
                v-model="form.arrdress"
                placeholder="請選擇自取地點"
                @change="handChange"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item
              :label="way === 'self' ? '自取時間：' : '送貨時間：'"
              prop="time"
            >
              <el-select
                v-model="form.time"
                placeholder="請選擇時間"
                @change="handChange"
                style="display: block; max-width: 100%"
              >
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item v-if="way !== 'self'" label="送貨地區" prop="area">
              <el-select
                v-model="form.area"
                placeholder="請選擇送貨地區"
                @change="handChange"
                clearable
                style="display: block; max-width: 100%"
                class="select"
              >
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :value="item.lable"
                  :label="item.lable"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item
              v-if="way !== 'self'"
              label="送貨地址"
              prop="deliveryAddress"
            >
              <el-input
                v-model="form.deliveryAddress"
                @change="handChange"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item label="其他要求：">
              <el-input
                type="textarea"
                autosize
                v-model="form.claim"
                @change="handChange"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item label="餐具：">
              <div class="tableware">
                <div ref="content1">
                  {{ content1 }}
                  <div v-if="additional.tableware !== 0">
                    額外追加 {{ additional.tableware }} 套餐具 [+HK${{
                      additional.tableware * additional.tablewarePrice
                    }}]
                  </div>
                  <div v-if="additional.tableware !== 0">
                    共
                    {{
                      parseInt(additional.tableware) +
                      parseInt(meal.tableware || 0)
                    }}
                    套餐具
                  </div>
                </div>
                <div>
                  <el-button @click="buy('tableware')">
                    <i class="el-icon-plus"></i>
                    購買額外餐具
                  </el-button>
                  <el-button ref="btn1" @click="no('tableware', $event)">
                    <i class="el-icon-close" @click="del('tableware')"></i>
                    不須任何餐具
                  </el-button>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item label="食物夾：">
              <div class="tableware">
                <div ref="content2">
                  {{ content2 }}
                  <div v-if="additional.clamp !== 0">
                    額外追加 {{ additional.clamp }} 個食物夾 [+HK${{
                      additional.clamp * additional.clampPrice
                    }}]
                  </div>
                  <div v-if="additional.clamp !== 0">
                    共
                    {{ parseInt(additional.clamp) + parseInt(meal.clamp || 0) }}
                    套個食物夾
                  </div>
                </div>
                <div>
                  <el-button @click="buy('clamp')">
                    <i class="el-icon-plus"></i>
                    購買額外食物夾
                  </el-button>
                  <el-button ref="btn1" @click="no('clamp', $event)">
                    <i class="el-icon-close" @click="del('clamp')"></i>
                    不須任何食物夾
                  </el-button>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <div class="buyDialog">
      <el-dialog :visible.sync="buyVisible1" width="25%" center>
        <div class="buyContent">
          <h6>請輸入需要購買多少套額外餐具</h6>
          <h6>[HK$3/份]</h6>
          <div class="ninput">
            <el-input
              size="mini"
              type="number"
              min="0"
              v-model="additional.tableware"
            >
            </el-input>
            <el-button size="mini" type="warning" @click="sub('tableware')"
              >確定</el-button
            >
          </div>
          <div>
            <h6>
              額外追加 {{ additional.tableware || 0 }} 套餐具 [+HK${{
                parseInt(additional.tableware) * additional.tablewarePrice || 0
              }}]
            </h6>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="buyDialog">
      <el-dialog :visible.sync="buyVisible2" width="25%" center>
        <div class="buyContent">
          <h6>請輸入需要購買多少個額外食物夾</h6>
          <h6>[HK$5/份]</h6>
          <div class="ninput">
            <el-input
              size="mini"
              type="number"
              min="0"
              v-model="additional.clamp"
            >
            </el-input>
            <el-button size="mini" type="warning" @click="sub('clamp')"
              >確定</el-button
            >
          </div>
          <div>
            <h6>
              額外追加 {{ additional.clamp || 0 }} 個食物夾 [+HK${{
                parseInt(additional.clamp) * additional.clampPrice
              }}}]
            </h6>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import "./form.css";
import order from "./order.vue";
export default {
  props: ["meal", "way", "form", "additional"],
  components: {
    "v-order": order,
  },
  mounted() {},
  data() {
    return {
      content1: `隨餐附送 ${this.meal.tableware || 0} 份免費餐具`,
      content2: `隨餐附送 ${this.meal.clamp || 0} 個食物夾`,
      buyVisible1: false,
      buyVisible2: false,
      labelPosition: "left",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() - 259200000 < Date.now() - 8.64e7;
        },
      },
      options: [
        {
          value: "觀塘 - 香港 觀塘 開源道62號 駱駝漆大廈 1座 12樓 D室",
          label: "觀塘",
        },
      ],
      options1: [
        {
          value: "10:00 - 10:30",
          label: "10:00 - 10:30",
        },
        {
          value: "10:30 - 11:00",
          label: "10:30 - 11:00",
        },
        {
          value: "11:00 - 11:30",
          label: "11:00 - 11:30",
        },
        {
          value: "11:30 - 12:00",
          label: "11:30 - 12:00",
        },
        {
          value: "12:00 - 12:30",
          label: "12:00 - 12:30",
        },
        {
          value: "12:30 - 13:00",
          label: "12:30 - 13:00",
        },
        {
          value: "13:00 - 13:30",
          label: "13:00 - 13:30",
        },
        {
          value: "13:30 - 14:00",
          label: "13:30 - 14:00",
        },
        {
          value: "14:00 - 14:30",
          label: "14:00 - 14:30",
        },
        {
          value: "14:30 - 15:00",
          label: "14:30 - 15:00",
        },
        {
          value: "15:00 - 15:30",
          label: "15:00 - 15:30",
        },
        {
          value: "15:30 - 16:00",
          label: "15:30 - 16:00",
        },
        {
          value: "16:00 - 16:30",
          label: "16:00 - 16:30",
        },
        {
          value: "16:30 - 17:00",
          label: "16:30 - 17:00",
        },
        {
          value: "17:00 - 17:30",
          label: "17:00 - 17:30",
        },
        {
          value: "17:30 - 18:00",
          label: "17:30 - 18:00",
        },
        {
          value: "18:00 - 18:30",
          label: "18:00 - 18:30",
        },
        {
          value: "18:30 - 19:00",
          label: "18:30 - 19:00",
        },
        {
          value: "19:00 - 19:30",
          label: "19:00 - 19:30",
        },
        {
          value: "19:30 - 20:00",
          label: "19:30 - 20:00",
        },
      ],
      options2: [
        {
          value:
            "僅限觀塘市中心（但不包括牛頭角；秀茂坪；藍田；九龍灣） [ +$60  ] ",
          lable:
            "僅限觀塘市中心（但不包括牛頭角；秀茂坪；藍田；九龍灣） [ +$60  ] ",
        },
        {
          value: " 九龍區（不包括將軍澳區） [ +$150  ] ",
          lable: " 九龍區（不包括將軍澳區） [ +$150  ] ",
        },
        {
          value: " 港島區 [ +$200  ] ",
          lable: " 港島區 [ +$200  ] ",
        },
        {
          value:
            " 新界區（如禁區、羅湖、沙頭角、迪士尼、機場、海洋公園、離島及馬灣等偏遠地區將收取額外運費） [ +$220  ] ",
          lable:
            " 新界區（如禁區、羅湖、沙頭角、迪士尼、機場、海洋公園、離島及馬灣等偏遠地區將收取額外運費） [ +$220  ] ",
        },
      ],
      rules: {
        date: [{ required: true, message: "請選擇日期", trigger: "change" }],
        deliveryAddress: [
          { required: true, message: "請輸入地址", trigger: "blur" },
        ],
        time: [{ required: true, message: "請選擇時間", trigger: "change" }],
        area: [
          { required: true, message: "請選擇送貨地區", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    //不須餐具和食物夾
    no(value, e) {
      if (e.target.innerText !== "") {
        if (value === "tableware") {
          this.content1 = e.target.innerText;
          this.$set(this.additional, "tableware", 0);
          this.$set(this.form, "tableware", this.additional.tableware);
        } else {
          this.content2 = e.target.innerText;
          this.$set(this.additional, "clamp", 0);
          this.$set(this.form, "clamp", this.additional.clamp);
        }
      }
    },
    // 同上
    del(val) {
      if (val === "tableware") {
        this.content1 = `隨餐附送 ${this.meal.tableware || 0} 份免費餐具`;
        this.$set(this.form, "tableware", this.meal.tableware);
        this.$set(this.additional, "tableware", 0);
      } else {
        this.content2 = `隨餐附送 ${this.meal.clamp || 0} 個食物夾`;
        this.$set(this.additional, "clamp", 0);
        this.$set(this.form, "clamp", this.meal.clamp);
      }
    },
    // 購買餐具和食物夾
    buy(val) {
      if (val === "tableware") {
        this.buyVisible1 = true;
      } else {
        this.buyVisible2 = true;
      }
    },
    sub(val) {
      if (val === "tableware") {
        if (this.additional.tableware !== 0) {
          this.$set(
            this.form,
            "tableware",
            (parseInt(this.meal.tableware) || 0) +
              parseInt(this.additional.tableware)
          );
          this.content1 = `隨餐附送 ${this.meal.tableware || 0} 份免費餐具`;
          this.buyVisible1 = false;
        }
      } else {
        if (this.additional.clamp !== 0) {
          this.$set(
            this.form,
            "clamp",
            (parseInt(this.meal.clamp) || 0) + parseInt(this.additional.clamp)
          );
          this.content2 = `隨餐附送 ${this.meal.clamp || 0} 個食物夾`;
          this.buyVisible2 = false;
        }
      }
    },
    handChange() {
      // console.log(this.form);
    },
    // 表單驗證
    //子组件校验，传递到父组件
    validateForm() {
      let flag = null;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          flag = true;
        } else {
          flag = false;
        }
      });
      return flag;
    },
    // 表單清空
    delForm() {
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>
<style scoped>
.order {
  padding: 0.25rem 0.5rem;
}
.orderform {
  margin: 0.6rem 0;
}
.form-item {
  width: 100%;
}

.form-item .tableware > div:first-child {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  height: auto;
  padding: 0 1rem;
  font-size: 14px;
  color: #707070;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.buyDialog .buyContent {
  padding: 1rem;
}
.buyDialog .ninput {
  width: 80%;
  margin: 1rem auto;
  display: flex;
}
::v-deep .form-item .tableware > div:last-child button {
  border: 1px dashed #fd9d20 !important;
}
::v-deep .orderform .el-input {
  width: 100%;
}
::v-deep .orderform .el-button:hover,
.orderform .el-button:focus {
  background: #fff;
  color: #707070;
}
/*
::v-deep .orderform .el-form-item__content {
  text-align: right;
} */
</style>
<style>
.el-select-dropdown{
  max-width: 26% !important;
}
</style>
